<script>
import Paginate from 'vuejs-paginate'
import noticeApi from './notice'
import NoticePopup from './NoticePopup.vue'

const LIST_STATE_KEY = 'notice_list_state'
const POPUP_NOTICE_LIMIT = 5 // 운영 정책에 맞게 조정

export default {
  name: 'NoticeList',
  components: {
    Paginate
  },
  data () {
    return {
      userInfo: {},
      userInfoDetail: {},
      list: [],
      page: 1,
      size: 10,
      totalCount: 0,
      pageCount: 1,
      loading: false
    }
  },
  computed: {
    canManageNotice () {
      const userRole = Number(this.userInfoDetail && this.userInfoDetail.userRole)

      return userRole === 1 || userRole === 5
    }
  },
  created () {
    this.userInfo = this.getUserInfo()
    this.userInfoDetail = this.getUserInfoDetail()
    this.restoreListState()
    this.getNoticeList()
  },
  methods: {
    getUserInfo () {
      let userInfo = {}

      try {
        userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}') || {}
      } catch (e) {
        userInfo = {}
      }

      return userInfo
    },
    getUserInfoDetail () {
      let userInfoDetail = {}

      try {
        userInfoDetail = JSON.parse(sessionStorage.getItem('userInfoDetail') || '{}') || {}
      } catch (e) {
        userInfoDetail = {}
      }

      return userInfoDetail
    },
    restoreListState () {
      const queryPage = parseInt(this.$route.query.page, 10)
      const querySize = parseInt(this.$route.query.size, 10)

      if (queryPage > 0) this.page = queryPage
      if (querySize > 0) this.size = querySize

      if (queryPage > 0 || querySize > 0) return

      try {
        const state = JSON.parse(sessionStorage.getItem(LIST_STATE_KEY) || '{}')
        if (parseInt(state.page, 10) > 0) this.page = parseInt(state.page, 10)
        if (parseInt(state.size, 10) > 0) this.size = parseInt(state.size, 10)
      } catch (e) {}
    },
    saveListState () {
      sessionStorage.setItem(LIST_STATE_KEY, JSON.stringify({
        page: this.page,
        size: this.size
      }))
    },
    getNoticeList () {
      this.loading = true
      noticeApi.getNotice({
        page: this.page,
        size: this.size
      }, response => {
        console.log('getNotice', response)
        this.loading = false

        if (!this.isSuccess(response)) {
          alert('공지사항 목록을 불러오지 못했습니다.')
          return
        }

        const normalized = this.normalizeListResponse(response)
        this.list = normalized.list
        this.totalCount = normalized.totalCount
        this.pageCount = normalized.pageCount

        if (this.page > this.pageCount && this.pageCount > 0) {
          this.page = this.pageCount
          this.getNoticeList()
        }
      })
    },
    normalizeListResponse (response) {
      const data = response && response.data ? response.data : response
      const result = data && data.result !== undefined ? data.result : data
      const body = result && result.body !== undefined ? result.body : result

      let list = []

      if (body && Array.isArray(body.list)) {
        list = body.list
      } else if (Array.isArray(body)) {
        list = body
      }

      const totalCount = Number(
        (body && body.totalElements !== undefined ? body.totalElements : null) ||
        (body && body.totalCount !== undefined ? body.totalCount : null) ||
        list.length
      )

      const pageCount = Number(
        (body && body.totalPage !== undefined ? body.totalPage : null) ||
        (body && body.totalPages !== undefined ? body.totalPages : null) ||
        Math.max(1, Math.ceil(totalCount / this.size))
      )

      return {
        list: list,
        totalCount: totalCount,
        pageCount: pageCount,
        hasNext: !!(body && body.hasNext)
      }
    },
    normalizeDetailResponse (response) {
      const data = response && response.data ? response.data : response
      const result = data && data.result !== undefined ? data.result : data
      const body = result && result.body !== undefined ? result.body : result

      if (!body || typeof body !== 'object' || Array.isArray(body)) {
        return null
      }

      return {
        noticePid: body.noticePid,
        userPid: body.userPid,
        subject: body.subject || '',
        content: body.content || '',
        showPopup: !!body.showPopup,
        regDate: body.regDate || '',
        updDate: body.updDate || ''
      }
    },
    isSuccess (response) {
      const data = response && response.data ? response.data : response
      return !data || data.resultCode === undefined || data.resultCode === 1 || data.resultCode === '1'
    },
    checkNoticeManageAuth () {
      if (this.canManageNotice) return true

      alert('공지사항 관리 권한이 없습니다.')
      return false
    },
    addNotice () {
      if (!this.checkNoticeManageAuth()) return

      this.saveListState()
      this.$router.push({
        name: 'NoticeForm',
        query: {
          page: this.page,
          size: this.size
        }
      })
    },
    viewNotice (item) {
      if (!item || !item.noticePid) return

      noticeApi.getNotice({
        noticePid: item.noticePid
      }, response => {
        console.log(`getNotice noticePid: ${item.noticePid}`, response)
        if (!this.isSuccess(response)) {
          alert('공지사항을 불러오지 못했습니다.')
          return
        }

        const notice = this.normalizeDetailResponse(response)

        if (!notice) {
          alert('공지사항 정보를 불러오지 못했습니다.')
          return
        }

        this.openNoticePopup(notice)
      })
    },
    openNoticePopup (notice) {
      this.$modal.show(NoticePopup, {
        notice: notice,
        userInfo: this.userInfo,
        userRole: this.userInfoDetail.userRole,
        isAdmin: this.canManageNotice,
        showTodayOption: false,
        modalName: 'noticeViewModal',
        onEdit: target => {
          this.$modal.hide('noticeViewModal')
          this.editNotice(target)
        },
        onDelete: target => {
          return this.deleteNotice(target, true)
        },
        onTogglePopup: (target, nextShow) => {
          return this.togglePopup(target, nextShow)
        }
      }, {
        name: 'noticeViewModal',
        width: 760,
        height: 'auto',
        adaptive: true,
        scrollable: true,
        classes: 'popup_modal'
      })
    },
    editNotice (item) {
      if (!this.checkNoticeManageAuth()) return
      if (!item || !item.noticePid) return

      this.saveListState()
      this.$router.push({
        name: 'NoticeForm',
        query: {
          noticePid: item.noticePid,
          page: this.page,
          size: this.size
        }
      })
    },
    deleteNotice (item, closePopup) {
      if (!this.checkNoticeManageAuth()) return
      if (!item || !item.noticePid) return Promise.resolve(false)
      if (!window.confirm('삭제하시겠습니까?')) return Promise.resolve(false)

      return new Promise(resolve => {
        noticeApi.deleteNotice('delete', {
          noticePid: item.noticePid
        }, response => {
          if (!this.isSuccess(response)) {
            alert('공지사항 삭제에 실패했습니다.')
            resolve(false)
            return
          }

          alert('삭제되었습니다.')
          if (closePopup) this.$modal.hide('noticeViewModal')
          this.getNoticeList()
          resolve(true)
        })
      })
    },
    togglePopup (item, nextShow) {
      if (!this.checkNoticeManageAuth()) return
      if (!item || !item.noticePid) return Promise.resolve(false)

      return new Promise(resolve => {
        const update = () => {
          noticeApi.postNotice('post', {
            noticePid: item.noticePid,
            showPopup: !!nextShow
          }, response => {
            if (!this.isSuccess(response)) {
              alert('팝업 설정 변경에 실패했습니다.')
              resolve(false)
              return
            }

            this.$set(item, 'showPopup', !!nextShow)
            this.getNoticeList()
            resolve(true)
          })
        }

        if (!nextShow) {
          update()
          return
        }

        noticeApi.getNotice({
          showPopup: true,
          size: POPUP_NOTICE_LIMIT
        }, response => {
          if (!this.isSuccess(response)) {
            alert('현재 팝업 공지 개수를 확인하지 못했습니다.')
            resolve(false)
            return
          }

          const popupList = this.normalizeListResponse(response).list || []
          const alreadyOn = popupList.some(popup => String(popup.noticePid) === String(item.noticePid))

          if (!alreadyOn && popupList.length >= POPUP_NOTICE_LIMIT) {
            alert('팝업 공지는 최대 ' + POPUP_NOTICE_LIMIT + '개까지 설정할 수 있습니다.')
            resolve(false)
            return
          }

          update()
        })
      })
    },
    movePage (page) {
      if (this.page === page) return
      this.page = page
      this.saveListState()
      this.getNoticeList()
    },
    changeSize () {
      this.page = 1
      this.saveListState()
      this.getNoticeList()
    },
    getDisplayNo (index) {
      if (this.totalCount > 0) {
        return this.totalCount - ((this.page - 1) * this.size) - index
      }
      return ((this.page - 1) * this.size) + index + 1
    },
    getDateText (item) {
      const value = item.updDate || item.regDate || ''
      if (!value) return '-'
      return String(value).replace('T', ' ').substring(0, 16)
    }
  }
}
</script>

<template>
  <div id="notice_list">
    <div class="common_tit_wrap">
      <div class="common_page_tit">공지사항</div>
    </div>

    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model.number="size" @change="changeSize">
            <option :value="10">10개씩 보기</option>
            <option :value="20">20개씩 보기</option>
            <option :value="50">50개씩 보기</option>
          </select>
        </div>
        <div v-if="canManageNotice" class="btn_top btn_green" @click="addNotice">
          신규 공지사항 등록
        </div>
      </div>

      <div class="common_list_middle notice_table">
        <div class="common_list_head">
          <div class="col_no"><span>No</span></div>
          <div class="col_subject"><span>제목</span></div>
          <div class="col_writer"><span>작성자</span></div>
          <div class="col_date"><span>작성일</span></div>
          <div class="col_popup" v-if="canManageNotice"><span>팝업</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="!loading && list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>공지사항이 없습니다.</span>
          </div>
          <div class="common_list_no_data" v-else-if="loading">
            <span>공지사항을 불러오는 중입니다.</span>
          </div>
          <div :key="'notice_' + item.noticePid" v-for="(item, index) in list">
            <div class="col_no"><span>{{ getDisplayNo(index) }}</span></div>
            <div class="col_subject">
              <span class="link fc_primary_blue notice_subject" @click="viewNotice(item)">{{ item.subject }}</span>
            </div>
            <div class="col_writer">
              <span>
                <template v-if="item.userId && item.userName">{{ item.userName }}<br>({{ item.userId }})</template>
                <template v-else>-</template>
              </span>
            </div>
            <div class="col_date"><span>{{ getDateText(item) }}</span></div>
            <div class="col_popup" v-if="canManageNotice">
              <button
                type="button"
                class="popup_toggle_btn"
                :class="item.showPopup ? 'on' : 'off'"
                @click.stop="togglePopup(item, !item.showPopup)"
              >
                {{ item.showPopup ? 'ON' : 'OFF' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="common_bottom_wrap">
        <div class="common_list_page_wrap center_page" v-if="pageCount > 1">
          <paginate
            :page-count="pageCount"
            :click-handler="movePage"
            :prev-text="'이전'"
            :next-text="'다음'"
            :container-class="'page_wrap'"
            :page-class="'page_item'"
            :active-class="'active'"
            :force-page="page"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#notice_list {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

.notice_table .col_no {
  width: 80px;
  flex-shrink: 0;
}

.notice_table .col_subject {
  flex: 1;
  min-width: 0;
}

.notice_table .col_writer {
  width: 160px;
  flex-shrink: 0;
}

.notice_table .col_date {
  width: 180px;
  flex-shrink: 0;
}

.notice_table .col_popup {
  width: 120px;
  flex-shrink: 0;
}

.notice_subject {
  display: block;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.popup_toggle_btn {
  display: block;
  width: 58px;
  height: 28px;
  border: 0;
  border-radius: 4px;
  margin: auto;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

.popup_toggle_btn.on {
  background: #4BA06C;
}

.popup_toggle_btn.off {
  background: #E33958;
}

.popup_toggle_btn:disabled {
  opacity: 0.6;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeList.vue